module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"includeCAPEXLabel":"CAPEX berücksichtigen?","includeCAPEX":"CAPEX-Massnahmen berücksichtigt","excludeCAPEX":"CAPEX-Massnahmen nicht berücksichtigt"}}')
  delete Component.options._Ctor
}
